import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Form } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * UiDropdown
 * Display the semantic component Dropdown wrapped within formular with the corresponding mode
 * Props (parameters)
 * @param string id
 * @param arrayOf(PropTypes.object) options: [{text, value}]
 * @param string value
 * @param bool selection: A dropdown can be used to select between choices in a form.
 * @param func onChange
 * @param bool multiple: A selection dropdown can allow multiple selections.
 * @param string text
 * @param bool floating: A dropdown menu can contain floated content.
 * @param string label
 * @param bool button: Format the Dropdown to appear as a button.
 * @param number width
 * @param bool disabled
 * @param bool fluid: A dropdown can take the full width of its parent
 * @param bool search: A selection dropdown can allow a user to search through a
 * large list of choices. Pass a function here to replace the default search.
 * @param bool compact: A compact dropdown has no minimum width
 * @param string mode
 */
export default class UiDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    this.toggleHover = this.toggleHover.bind(this);
    this.state = {
      hover: false,
    };
  }

  /**
   * Toggle hover
   */
  toggleHover() {
    const { hover } = this.state;
    this.setState({ hover: !hover });
  }

  render() {
    const {
      id,
      options,
      value,
      selection,
      onChange,
      multiple,
      text,
      floating,
      label,
      button,
      width,
      fluid,
      disabled,
      search,
      compact,
      mode,
    } = this.props;
    const { hover } = this.state;
    let style = {};
    let styleLabel = {};

    if (mode !== null) {
      const colors = colorsModeUI(mode);
      style.backgroundColor = colors.INPUT_BACKGROUND_COLOR;
      style.color = colors.INPUT_COLOR;
      style.borderColor = hover
        ? colors.INPUT_FOCUS_BORDER_COLOR
        : colors.INPUT_BORDER_COLOR;
      styleLabel.color = colors.INPUT_LABEL_COLOR;

      if (disabled) {
        style = {
          color: colors.INPUT_DISABLED,
          backgroundColor: colors.INPUT_BACKGROUND_COLOR,
          borderColor: colors.INPUT_DISABLED,
        };
        styleLabel = {
          color: colors.INPUT_DISABLED,
        };
      }
    }

    const dropdown = (
      <Dropdown
        id={id}
        options={options}
        value={value}
        selection={selection}
        onChange={onChange}
        style={style}
        className={`${mode !== null ? 'ui-dropdown' : ''}`}
        onMouseEnter={this.toggleHover}
        onMouseLeave={this.toggleHover}
        multiple={multiple}
        text={text}
        floating={floating}
        button={button}
        disabled={disabled}
        fluid={fluid}
        search={search}
        compact={compact}
      />
    );

    return (
      <Form.Field
        className="ui-dropdown-wrapper"
        width={width !== null ? width : 16}
      >
        {label && (
          <span className="label-dropdown" style={styleLabel}>
            {label}
          </span>
        )}
        {dropdown}
      </Form.Field>
    );
  }
}

UiDropdown.propTypes = {
  id: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  selection: PropTypes.bool,
  onChange: PropTypes.func,
  multiple: PropTypes.bool,
  text: PropTypes.string,
  floating: PropTypes.bool,
  label: PropTypes.string,
  button: PropTypes.bool,
  width: PropTypes.number,
  disabled: PropTypes.bool,
  fluid: PropTypes.bool,
  search: PropTypes.bool,
  compact: PropTypes.bool,
  mode: PropTypes.string,
};

UiDropdown.defaultProps = {
  id: null,
  options: [],
  value: null,
  selection: false,
  onChange: () => {},
  multiple: false,
  text: '',
  floating: false,
  label: null,
  button: false,
  width: null,
  disabled: false,
  fluid: false,
  mode: null,
  compact: false,
  search: false,
};
